import { render, staticRenderFns } from "./SpecialModal.vue?vue&type=template&id=a2a9c4e4&lang=pug&"
import script from "./SpecialModal.vue?vue&type=script&lang=js&"
export * from "./SpecialModal.vue?vue&type=script&lang=js&"
import style0 from "./SpecialModal.vue?vue&type=style&index=0&id=a2a9c4e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports